import React, { useEffect, useState } from "react";
import Loader from "../components/common/Loader";
import ErrorState from "../components/common/ErrorState";
import settingsService from "../services/settingsService";

export default function Settings() {
  const [form, setForm] = useState({ name: "", logo: "", favicon: "", footer_text: "" });
  const [state, setState] = useState("loading");
  const [saving, setSaving] = useState(false);
  const [savedAt, setSavedAt] = useState(null);
  const [error, setError] = useState("");

  function load() {
    setState("loading");
    settingsService
      .get()
      .then((res) => {
        setForm({
          name: res.data?.name || "",
          logo: res.data?.logo || "",
          favicon: res.data?.favicon || "",
          footer_text: res.data?.footer_text || "",
        });
        setState("ready");
      })
      .catch(() => setState("error"));
  }

  useEffect(load, []);

  async function handleSave(e) {
    e.preventDefault();
    setSaving(true);
    setError("");
    try {
      await settingsService.update(form);
      setSavedAt(new Date());
    } catch (err) {
      setError(err.friendlyMessage || "Could not save settings.");
    } finally {
      setSaving(false);
    }
  }

  if (state === "loading") return <div className="pm-page"><Loader label="Loading settings" /></div>;
  if (state === "error") return <div className="pm-page"><ErrorState onRetry={load} /></div>;

  return (
    <div className="pm-page">
      <header className="pm-page__header">
        <div>
          <span className="pm-eyebrow">Configuration</span>
          <h1>Settings</h1>
        </div>
      </header>

      <form className="pm-card pm-modal-form" onSubmit={handleSave} style={{ maxWidth: 520 }}>
        <div className="pm-field">
          <label>Organisation name</label>
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Positive Moves Consulting" />
        </div>
        <div className="pm-field">
          <label>Logo URL</label>
          <input value={form.logo} onChange={(e) => setForm({ ...form, logo: e.target.value })} placeholder="https://…" />
        </div>
        <div className="pm-field">
          <label>Favicon URL</label>
          <input value={form.favicon} onChange={(e) => setForm({ ...form, favicon: e.target.value })} placeholder="https://…" />
        </div>
        <div className="pm-field">
          <label>Footer text</label>
          <textarea rows={3} value={form.footer_text} onChange={(e) => setForm({ ...form, footer_text: e.target.value })} />
        </div>
        {error && <div className="pm-form-error">{error}</div>}
        <button className="pm-btn pm-btn--primary" disabled={saving} type="submit">
          {saving ? "Saving…" : "Save settings"}
        </button>
        {savedAt && <span className="pm-saved-note">Saved {savedAt.toLocaleTimeString()}</span>}
      </form>
    </div>
  );
}
